import { render } from "./WalletButton.vue?vue&type=template&id=52c470ca&scoped=true&ts=true"
import script from "./WalletButton.vue?vue&type=script&lang=ts"
export * from "./WalletButton.vue?vue&type=script&lang=ts"

import "./WalletButton.vue?vue&type=style&index=0&id=52c470ca&scoped=true&lang=scss"

import exportComponent from "/Users/Matt/projects/betherance/betherswap/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c470ca"]])

export default __exports__